// gatsby-browser.tsx

import * as React from "react"
import type { GatsbyBrowser } from "gatsby"
import { AuthProvider } from "./src/context/AuthContext"
import { ThemeProvider } from "./src/context/ThemeContext"
import MaintenanceGate from "./src/components/MaintenanceGate";
import { captureUtmData } from "./src/function/utmTracking";

// Захоплення UTM/referrer у localStorage ОДИН РАЗ на реальне завантаження
// (не на кожен SPA-перехід) — детальніше в src/function/utmTracking.js.
export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
    captureUtmData();
}

// Meta Pixel PageView на кожен перехід між сторінками — базовий код у
// gatsby-ssr.tsx стріляє PageView лише при першому (SSR) завантаженні,
// подальша навігація в Gatsby — це SPA-переходи без повного перезавантаження.
export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = () => {
    if (typeof window !== "undefined" && typeof (window as any).fbq === "function") {
        (window as any).fbq("track", "PageView");
    }
}

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element, props }) => {
    // Передаємо props у Layout
    // console.log("GatsbyBrowser-element:", element);
    // console.log("GatsbyBrowser-props:", props);
    return (
        <ThemeProvider>
            <AuthProvider>
                <MaintenanceGate props={props}>
                    {element}
                </MaintenanceGate>
            </AuthProvider>
        </ThemeProvider>
    )
}
